import { Component, OnInit } from '@angular/core';
import { ErrorService } from '../../services/error.service';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss'],
})
export class ErrorPopupComponent implements OnInit {
  public showError = this.errorService.isErrorVisible;
  public errorMessage = this.errorService.errorMessage;

  constructor(public errorService: ErrorService) {}

  ngOnInit() {}
}
